export const language_config={
    ja: {
      text: 'Japanese',
      icon: require('../../assets/images/language/ja.png'),
      file: require('./ja.js')
    }
  }